export default __webpack_public_path__ + "static/media/monaco-team-offer-discount-20-top.5410f46d.png";